'use client'

import { useSyncExternalStore } from 'react'

/**
 * Open/closed state for the small-screen site menu, shared by its two
 * triggers (the hamburger in the header on tablets, the Menu tab in the
 * bottom bar on phones) and the drawer itself. A module store keeps it out
 * of Redux: nothing else reads it, and the drawer mounts once in AppHeader.
 */
let open = false
const listeners = new Set<() => void>()

function emit() {
  for (const l of listeners) l()
}

export function openMobileMenu() {
  if (open) return
  open = true
  emit()
}

export function closeMobileMenu() {
  if (!open) return
  open = false
  emit()
}

export function toggleMobileMenu() {
  open = !open
  emit()
}

function subscribe(l: () => void) {
  listeners.add(l)
  return () => {
    listeners.delete(l)
  }
}

export function useMobileMenuOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => open,
    () => false
  )
}
